import React, {useContext, useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import styled from "styled-components";
import {RootContext} from "../../with-root";
import {AssetContext} from "../../provider/asset";
import "./index.css";

const Logo = styled.img`
  height: 67px;
  width: 100%;
  object-fit: contain;
`;

const SponsorContainer = styled.div`
  background: ${(props) => props.theme.background.sponsors};
`;

const GreyParagraph = styled.p`
  color: #636363;
`;

export default () => {
  const [hydrated, setHydrated] = useState(false);
  const intl = useIntl();
  const {logosInverted} = useContext(RootContext);
  const {isGemeinschafts} = useContext(AssetContext);

  useEffect(() => {
    setHydrated(true);
    console.info(`Logos inverted: ${logosInverted}`);
  }, [logosInverted]);

  if (!hydrated) return null;

  console.info(`Sponsors: isGemeinschafts=${isGemeinschafts}`); // TODO remove debug messages after test
  const defaultSponsors = [
    {
      src: "/sponsor/philatelie.svg",
      alt: intl.formatMessage({id: "logo.philatelie.alt"}),
      href: intl.formatMessage({id: "link.philatelie"}),
      className: logosInverted ? "filter-white" : ""
    },
    {
      src: "/sponsor/pli.svg",
      alt: intl.formatMessage({id: "logo.pli.alt"}),
      href: "https://www.post.li",
      className: logosInverted ? "filter-white" : ""
    },
    {
      src: "/sponsor/dynamicelement-logo-dark.svg",
      alt: intl.formatMessage({id: "logo.dynamic.element.alt"}),
      href: "http://www.dynamicelement.com/",
      className: logosInverted ? "filter-white" : ""
    },
    {
      src: logosInverted ? "/sponsor/originstamp-logo-white.svg" : "/sponsor/originstamp-logo-dark.svg",
      alt: intl.formatMessage({id: "logo.originstamp.alt"}),
      href: "https://originstamp.com",
      className: ""
    }
  ];

  const gemeinschaftsSponsor = [
    {
      src: "/sponsor/post_swiss.svg",
      alt: intl.formatMessage({id: "logo.swiss.alt"}),
      href: intl.formatMessage({id: "link.post_swiss"}),
      className: ""
    },
    {
      src: logosInverted ? "/sponsor/inacta_neg.svg" : "/sponsor/inacta_rgb.svg",
      alt: intl.formatMessage({id: "logo.inacta.alt"}),
      href: "https://inacta.ch/",
      className: ""
    },
    {
      src: "/sponsor/philatelie.svg",
      alt: intl.formatMessage({id: "logo.philatelie.alt"}),
      href: intl.formatMessage({id: "link.philatelie"}),
      className: logosInverted ? "filter-white" : ""
    },
    {
      src: "/sponsor/pli.svg",
      alt: intl.formatMessage({id: "logo.pli.alt"}),
      href: "https://www.post.li",
      className: logosInverted ? "filter-white" : ""
    },
    {
      src: "/sponsor/dynamicelement-logo-dark.svg",
      alt: intl.formatMessage({id: "logo.dynamic.element.alt"}),
      href: "http://www.dynamicelement.com/",
      className: logosInverted ? "filter-white" : ""
    },
    {
      src: logosInverted ? "/sponsor/originstamp-logo-white.svg" : "/sponsor/originstamp-logo-dark.svg",
      alt: intl.formatMessage({id: "logo.originstamp.alt"}),
      href: "https://originstamp.com",
      className: ""
    }
  ];

  const sponsors = isGemeinschafts ? gemeinschaftsSponsor : defaultSponsors;

  return (
    <>
      <SponsorContainer className="pt-4">
        <div className="container pt-5 mt-pd-5 pb-3">
          <div className="row">
            {sponsors.map((sponsor) => {
              const colSize = Math.floor(12 / sponsors.length); // integer col size
              const colClass = `col-12 col-md-${colSize} text-center mb-4 my-md-0`;

              return (
                <div className={colClass}>
                  <a href={sponsor.href} target="__blank">
                    <Logo src={sponsor.src} className={sponsor.className} alt={sponsor.alt} />
                  </a>
                </div>
              );
            })}
          </div>
          <div className={"row justify-content-center"}>
            <div className={(logosInverted ? "invisible" : "") + " col-10 col-md-12"}>
              <div className="mb-5 mt-3 my-md-5 rfs-small">
                <GreyParagraph className="text-center mb-1">
                  <FormattedMessage id="sponsors.subtext.1" /> -{" "}
                  <a
                    href={intl.formatMessage({id: "link.shop"})}
                    className="text-turquoise"
                    target="__blank"
                  >
                    <FormattedMessage id="link.buy.now" />
                  </a>
                </GreyParagraph>
                <GreyParagraph className="text-center">
                  <FormattedMessage id="sponsors.subtext.2" />{" "}
                  <a
                    href="https://www.dynamicelement.com"
                    className="text-turquoise"
                    target="__blank"
                  >
                    <FormattedMessage id="company.dynamic.element" />
                  </a>{" "}
                  <FormattedMessage id="plain.and" />{" "}
                  <a
                    href="https://originstamp.com"
                    className="text-turquoise"
                    target="__blank"
                  >
                    <FormattedMessage id="company.originstamp" />
                  </a>
                  .
                </GreyParagraph>
              </div>
            </div>
          </div>
        </div>
      </SponsorContainer>
    </>
  );
};
